<div class="container-fluid">
  <div *ngIf="message && !isDraft && loading"><wl-busy [show]="loading"></wl-busy></div>
  <div class="row">
    <div *ngIf="message.MessageSent" class="pull-right">
      <action-button
        [label]="'communications.mass-comm-message-edit.analytics.resend.select-button.title' | translate | uppercase"
        [items]="menuResendEmailOptions"
      >
      </action-button>
    </div>
  </div>
  <div *ngIf="message && !isDraft && !loading">
    <div class="mct-flex mct-col mct-items-stretch mct-justify-between mct-items-stretch">
      <div style="min-width: 650px">
        <div class="pull-right">
          <button
            pButton
            type="button"
            class="atlas-btn atlas-btn-secondary"
            (click)="handleRefreshClick()"
            [disabled]="loadingStatistics"
            [icon]="loadingStatistics ? '' : 'pi pi-refresh'"
          >
            <wl-busy *ngIf="loadingStatistics" [show]="loadingStatistics"></wl-busy>
          </button>
        </div>
        <div *ngIf="!statistics && !loadingStatistics">
          {{ 'communications.mass-comm-message-edit.analytics.no-analytics-message' | translate }}
        </div>
        <div *ngIf="statistics">
          <ul class="simple-list spacier-list sideways-list">
            <li>
              <div class="wl-big-value wl-chart-text-grey text-center">{{ statistics.SendSuccessCount }}</div>
              <div class="text-center">
                <strong>{{ 'communications.mass-comm-message-edit.analytics.successful-sends-label' | translate | titlecase }}</strong>
              </div>
            </li>
            <li>
              <div class="wl-big-value wl-chart-text-green text-center">{{ statistics.UniqueReadCount }}</div>
              <div class="text-center">
                <strong>{{ 'communications.mass-comm-message-edit.analytics.opened-label' | translate | titlecase }}</strong>
              </div>
            </li>
            <li>
              <div class="wl-big-value wl-chart-text-purple text-center">{{ statistics.MessageClickUniqueCount }}</div>
              <div class="text-center">
                <strong>{{ 'communications.mass-comm-message-edit.analytics.clicked-label' | translate | titlecase }}</strong>
              </div>
            </li>
            <li>
              <div class="wl-big-value wl-chart-text-red text-center">{{ statistics.SendFailCount }}</div>
              <div class="text-center">
                <strong>{{ 'communications.mass-comm-message-edit.analytics.failed-sends-label' | translate | titlecase }}</strong>
              </div>
            </li>
          </ul>

          <div *ngIf="statistics.TotalSent > 0">
            <div>
              <span class="wl-progress-bar-label" [ngStyle]="{ 'min-width': openedPercentOfSucceeded | atlasPercent }">
                {{ 'communications.mass-comm-message-edit.analytics.bar-chart.opened-label' | translate | titlecase }}
                {{ openedPercentOfSucceeded | atlasPercent }}
              </span>
            </div>

            <div class="progress">
              <div
                class="progress-bar wl-chart-bar-green"
                *ngIf="openedPercentOfSucceeded > 0"
                [ngStyle]="{ width: openedPercentOfSucceeded | atlasPercent }"
              ></div>
            </div>
            <p>
              <button
                pButton
                type="button"
                class="atlas-btn atlas-btn-secondary"
                [disabled]="loadingStatistics"
                (click)="showReadDetails()"
                icon="pi pi-search"
                [label]="'communications.mass-comm-message-edit.analytics.view-details-button' | translate | titlecase"
              ></button>
              <a (click)="openProfileSelectorModal()" class="ml-20">{{
                'communications.mass-comm-message-edit.analytics.action-dropdown.open-recipients-profile-selector' | translate | titlecase
              }}</a>
            </p>
            <div>
              <span class="wl-progress-bar-label"
                >{{ 'communications.mass-comm-message-edit.analytics.bar-chart.clicked-label' | translate | titlecase }}
                {{ clickToReadPercent | atlasPercent }}
                {{ 'communications.mass-comm-message-edit.analytics.bar-chart.clicked-of-opened-label' | translate }}</span
              >
            </div>

            <div class="progress">
              <div
                class="progress-bar wl-chart-bar-purple"
                *ngIf="clickToReadPercent > 0"
                [ngStyle]="{ width: clickToReadPercent | atlasPercent }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="statistics">
      <p-table [showGridlines]="true"
        styleClass="wl-responsive-prime-datatable"
        [rows]="statistics.Clicks.length"
        [value]="statistics.Clicks"
        [totalRecords]="statistics.Clicks.length"
      >
        <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
          <p-button
            icon="pi pi-sort-alt"
            [rounded]="true"
            [text]="true"
            *ngIf="sortOrder === 0"
            aria-hidden="true"
            styleClass="wl-prime-datatable-column-advanced-sort-btn"
          />
          <p-button
            icon="pi pi-sort-amount-up-alt"
            [rounded]="true"
            [text]="true"
            *ngIf="sortOrder === 1"
            aria-hidden="true"
            styleClass="wl-prime-datatable-column-advanced-sort-btn"
          />
          <p-button
            icon="pi pi-sort-amount-down"
            [rounded]="true"
            [text]="true"
            *ngIf="sortOrder === -1"
            aria-hidden="true"
            styleClass="wl-prime-datatable-column-advanced-sort-btn"
          />
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th [pSortableColumn]="'Url'">
              {{ 'communications.mass-comm-message-edit.analytics.link-column-header' | translate | titlecase }}
              <p-sortIcon field="Url"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'ClickedTotal'" class="text-center" style="width: 150px">
              {{ 'communications.mass-comm-message-edit.analytics.click-count-column-header' | translate | titlecase }}
              <p-sortIcon field="ClickedTotal"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'clickPercent'" class="wl-prime-datatable-hidden-phone text-center" style="width: 130px">
              {{ 'communications.mass-comm-message-edit.analytics.click-percent-column-header' | translate | titlecase }}
              <p-sortIcon field="clickPercent"></p-sortIcon>
            </th>
            <th class="wl-prime-datatable-hidden-phone" style="width: 80px"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-click>
          <tr>
            <td>
              <div style="overflow: hidden">
                <a [href]="click.Url" target="_blank">{{ click.Url }}</a>
              </div>
              <div class="wl-prime-datatable-hidden-tablet-and-bigger">
                <button
                  pButton
                  type="button"
                  class="atlas-btn btn-xs atlas-btn-default"
                  [disabled]="loadingStatistics"
                  (click)="showClickDetails(click)"
                  icon="pi pi-search"
                ></button>
                <div>
                  <strong
                    >{{ 'communications.mass-comm-message-edit.analytics.click-count-column-header' | translate | titlecase }}:
                  </strong>
                  {{ click.ClickedTotal }}
                </div>
                <div>
                  <strong
                    >{{ 'communications.mass-comm-message-edit.analytics.click-atlasPercent-column-header' | translate | titlecase }}:
                  </strong>
                  {{ click.clickPercent | atlasPercent }}
                </div>
              </div>
            </td>
            <td class="text-center">{{ click.UniqueClick }}</td>
            <td class="wl-prime-datatable-hidden-phone text-center">{{ click.clickPercent | atlasPercent }}</td>
            <td class="wl-prime-datatable-hidden-phone">
              <button
                pButton
                type="button"
                class="atlas-btn atlas-btn-default"
                [disabled]="loadingStatistics"
                (click)="showClickDetails(click)"
                icon="pi pi-search"
              ></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p-progressSpinner *ngIf="loading"></p-progressSpinner>
    </div>
  </div>
</div>

<p-dialog
  #deliveryDetailsModal
  modal="true"
  [(visible)]="showDeliveryModal"
  [closable]="false"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 class="modal-title">{{ 'communications.mass-comm-message-edit.analytics.delivery-details-header' | translate | titlecase }}</h4>
  </ng-template>
  <wl-mass-comm-message-edit-analytics-delivery-details
    [messageId]="deliveryDetailMessageId"
    *ngIf="deliveryDetailMessageId"
  ></wl-mass-comm-message-edit-analytics-delivery-details>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-secondary"
      (click)="this.showDeliveryModal = false"
      icon="pi pi-ban"
      [label]="'common.close' | translate | titlecase"
    ></button>
  </ng-template>
</p-dialog>

<p-dialog
  #clickDetailsModal
  modal="true"
  [(visible)]="showClickModal"
  [closable]="false"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 class="modal-title">{{ 'communications.mass-comm-message-edit.analytics.click-details-header' | translate | titlecase }}</h4>
  </ng-template>
  <wl-mass-comm-message-edit-analytics-click-details
    [messageId]="clickDetailMessageId"
    [url]="clickDetailUrl"
    *ngIf="clickDetailMessageId && clickDetailUrl"
  ></wl-mass-comm-message-edit-analytics-click-details>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-secondary"
      (click)="this.showClickModal = false"
      icon="pi pi-ban"
      [label]="'common.close' | translate | titlecase"
    ></button>
  </ng-template>
</p-dialog>

<wl-mass-comm-profile-selector-dialog [message]="message"></wl-mass-comm-profile-selector-dialog>
<wl-mass-comm-message-edit-analytics-resend-dialog />
